import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useEnableWorkflowMutation, useUpdateEnabledWorkflowMutation } from '../../store/workflow/enabledWorkflows'
import { useCallback } from 'react'
import { WORKFLOWS } from './WorkflowMapping'
import { useGetEnabledWorkflows } from '../Integration/IntegrationManagement/AdminSettings/hooks'
import { BusinessEventExportWorkflowContext } from '../../models/Workflow'

export const useSaveBusinessEventExportWorkflow = () => {
  const accountId = useAppSelector(selectAccountId)
  const { businessEventExportWorkflowContext, businessEventExportWorkflowId } = useGetEnabledWorkflows()
  const [triggerEnableWorkflow] = useEnableWorkflowMutation()
  const [triggerUpdateEnabledWorkflow] = useUpdateEnabledWorkflowMutation()

  const saveBusinessEventExportWorkflow = useCallback(
    async (context: Partial<BusinessEventExportWorkflowContext>) => {
      if (businessEventExportWorkflowId) {
        const patchedContext = {
          ...businessEventExportWorkflowContext,
          ...context,
        }
        await triggerUpdateEnabledWorkflow({
          accountId,
          enabledWorkflowId: businessEventExportWorkflowId,
          payload: { context: patchedContext },
        }).unwrap()
      } else if (WORKFLOWS.businessEventExport.id) {
        await triggerEnableWorkflow({
          accountId,
          payload: {
            workflowId: WORKFLOWS.businessEventExport.id,
            context,
          },
        }).unwrap()
      }
    },
    [accountId, businessEventExportWorkflowContext, businessEventExportWorkflowId, triggerEnableWorkflow, triggerUpdateEnabledWorkflow],
  )

  return { saveBusinessEventExportWorkflow }
}
